import React, { useEffect, useState } from 'react';
import { SMALL_DEVICE_WIDTH } from '../constants';

export interface ScreenSizeContextState {
    isSmallDevice: boolean;
}

export const ScreenSizeContext = React.createContext<ScreenSizeContextState>({
    isSmallDevice: false,
});

const getIsSmallDevice = () => {
    if (window.innerWidth <= SMALL_DEVICE_WIDTH) {
        return true;
    } else {
        return false;
    }
}

export const ScreenSizeProvider: React.FC = (props) => {
    const [isSmallDevice, setIsSmallDevice] = useState(getIsSmallDevice());

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    });

    const handleResize = () => {
        setIsSmallDevice(getIsSmallDevice());
    }

    return (
        <ScreenSizeContext.Provider value={{ isSmallDevice }}>
            {props.children}
        </ScreenSizeContext.Provider>
    );
}
